export default {
    hero: {
        kicker: 'oase_aej',
        title: 'Ihr Online-Antragssystem für KJP-Fördermittel',
        text: 'Über oase_aej stellen Mitgliedsorganisationen der aej ihre Förderanträge im Rahmen des Kinder- und Jugendplans (KJP des Bundes) – von der Antragstellung bis zum Verwendungsnachweis.',
        contactLink: 'Zentralstelle aej kontaktieren',
        loginHint: 'Sie haben bereits Zugangsdaten?',
        loginLink: 'Jetzt einloggen'
    },
    features: {
        kicker: 'Leistungen',
        title: 'Was oase_aej für Sie übernimmt',
        text: 'Alle Schritte Ihres Förderverfahrens digital an einem Ort.',
        programs: {
            heading: 'Förderprogramme auswählen',
            text: 'Wählen Sie eines der KJP-Förderprogramme für Ihre Maßnahme aus.'
        },
        applications: {
            heading: 'Anträge stellen',
            text: 'Stellen Sie Ihren Förderantrag für die Maßnahme direkt online.'
        },
        usageProof: {
            heading: 'Verwendungsnachweise einreichen',
            text: 'Reichen Sie Ihren Verwendungsnachweis digital ein und dokumentieren Sie die sachgerechte Mittelverwendung.'
        },
        agreements: {
            heading: 'Verträge & Vereinbarungen unterschreiben',
            text: 'Rufen Sie Weiterleitungsvertrag und Zielvereinbarung der Zentralstelle aej ab und unterschreiben Sie sie direkt in oase_aej.'
        },
        tracking: {
            heading: 'Prozessstatus verfolgen',
            text: 'Behalten Sie jederzeit den Überblick über den Bearbeitungsstatus Ihrer Anträge und Maßnahmen.'
        }
    },
    process: {
        kicker: 'Ablauf',
        title: 'So funktioniert oase_aej',
        text: 'Von der Antragstellung bis zur Auswertung begleitet Sie die Zentralstelle aej durch das gesamte Förderverfahren.',
        step1: {
            heading: 'Antrag stellen',
            text: 'Sie stellen Ihren Antrag für die Maßnahme direkt in oase_aej.'
        },
        step2: {
            heading: 'Prüfung & Vereinbarungen',
            text: 'Die Zentralstelle aej prüft Ihren Antrag. Zielvereinbarung und Weiterleitungsvertrag werden im Gespräch abgestimmt und anschließend in oase_aej unterschrieben.'
        },
        step3: {
            heading: 'Bewilligung & Auszahlung',
            text: 'Nach der Bewilligung werden die Fördermittel ausgezahlt.'
        },
        step4: {
            heading: 'Nachweis & Auswertung',
            text: 'Nach Abschluss Ihrer Maßnahme reichen Sie den Verwendungsnachweis ein. Die Zielerreichung wird anschließend gemeinsam mit der Zentralstelle im Gespräch ausgewertet.'
        }
    },
    audience: {
        kicker: 'Zielgruppe',
        title: 'Für wen ist oase_aej?',
        text: 'oase_aej steht Mitgliedsorganisationen der aej offen, die in einem dieser Förderbereiche des Kinder- und Jugendplans (KJP) beantragen:',
        areas: {
            internationalMeetings: 'Internationale Begegnungen',
            internationalWorkcamps: 'Internationale Workcamps',
            associationWork: 'Jugendverbandsarbeit der Bundesstellen der Werke, Verbände und Freikirchen',
            politicalEducation: 'Netzwerkstellen der Politischen Bildung'
        }
    },
    access: {
        kicker: 'Zugang',
        title: 'Zugang erhalten',
        text: 'Der Zugang zu oase_aej erfolgt über die Zentralstelle aej. Wenden Sie sich für weitere Informationen und zur Beantragung eines Zugangs an die Zentralstelle.',
        contactLink: 'Zentralstelle aej kontaktieren',
        loginHint: 'Sie haben bereits Zugangsdaten?',
        loginLink: 'Jetzt einloggen'
    }
}
